import { render, staticRenderFns } from "./CarAdd.vue?vue&type=template&id=0d681d84&scoped=true&"
import script from "./CarAdd.vue?vue&type=script&lang=js&"
export * from "./CarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d681d84",
  null
  
)

export default component.exports